export const UPDATE_DISPLAY_CATE_DATA = 'UPDATE_DISPLAY_CATE_DATA'
export const UPDATE_DISPLAY_DATA = 'UPDATE_DISPLAY_DATA'
export const UPDATE_DISPLAY_PAGE = 'UPDATE_DISPLAY_PAGE'
export const PUSH_LIST_OF_CALLED_API = 'PUSH_LIST_OF_CALLED_API'
export const UPDATE_GORILLA_CHART_DATA = 'UPDATE_GORILLA_CHART_DATA'
export const UPDATE_CARD_CORP_DATA = 'UPDATE_CARD_CORP_DATA'
export const UPDATE_CARD_CORP_EVENT_DATA = 'UPDATE_CARD_CORP_EVENT_DATA'
export const UPDATE_CARD_DATA_FOR_SEARCH = 'UPDATE_CARD_DATA_FOR_SEARCH'
export const UPDATE_CARD_DATA_QUERY_AND_RESULT = 'UPDATE_CARD_DATA_QUERY_AND_RESULT'
export const UPDATE_BENEFIT_DATA_DEPTH = 'UPDATE_BENEFIT_DATA_DEPTH'
export const UPDATE_BENEFIT_DATA_FLAT = 'UPDATE_BENEFIT_DATA_FLAT'
export const UPDATE_CARD_COVER_DATA = 'UPDATE_CARD_COVER_DATA'
export const UPDATE_VIDEO_DATA = 'UPDATE_VIDEO_DATA'
export const CHANGE_OPEN_COMPARE_SLOT = 'CHANGE_OPEN_COMPARE_SLOT'
export const CHANGE_SIZE_COMPARE_SLOT = 'CHANGE_SIZE_COMPARE_SLOT'
export const CHANGE_SIZE_TOAST_BANNER = 'CHANGE_SIZE_TOAST_BANNER'
export const UPDATE_COMPARE_SLOT_DATA = 'UPDATE_COMPARE_SLOT_DATA'
export const UPDATE_COMPARE_RCMD_MODAL = 'UPDATE_COMPARE_RCMD_MODAL'
export const UPDATE_COMPARE_SLOT_POSITION = 'UPDATE_COMPARE_SLOT_POSITION'
export const UPDATE_CURRENT_CHART_TITLE = 'UPDATE_CURRENT_CHART_TITLE'
export const CHANGE_OPEN_ALL_CHART_DIALOG = 'CHANGE_OPEN_ALL_CHART_DIALOG'
export const CHANGE_OPEN_AWD1_DIALOG = 'CHANGE_OPEN_AWD1_DIALOG'
export const CHANGE_OPEN_AWD2_DIALOG = 'CHANGE_OPEN_AWD2_DIALOG'
export const CHANGE_OPEN_AWD3_DIALOG = 'CHANGE_OPEN_AWD3_DIALOG'
export const CHANGE_OPEN_AWD4_DIALOG = 'CHANGE_OPEN_AWD4_DIALOG'
export const CHANGE_OPEN_AWD5_DIALOG = 'CHANGE_OPEN_AWD5_DIALOG'
export const CHANGE_OPEN_SPE1_DIALOG = 'CHANGE_OPEN_SPE1_DIALOG'
export const CHANGE_OPEN_SPE2_DIALOG = 'CHANGE_OPEN_SPE2_DIALOG'
export const CHANGE_OPEN_SPE3_DIALOG = 'CHANGE_OPEN_SPE3_DIALOG'
export const CHANGE_OPEN_SPE4_DIALOG = 'CHANGE_OPEN_SPE4_DIALOG'
export const CHANGE_OPEN_RETURN1_DIALOG = 'CHANGE_OPEN_RETURN1_DIALOG'
export const CHANGE_OPEN_RETURN2_DIALOG = 'CHANGE_OPEN_RETURN2_DIALOG'
export const CHANGE_OPEN_RETURN3_DIALOG = 'CHANGE_OPEN_RETURN3_DIALOG'
export const CHANGE_OPEN_RETURN4_DIALOG = 'CHANGE_OPEN_RETURN4_DIALOG'
export const CHANGE_OPEN_CHECK_DIALOG = 'CHANGE_OPEN_CHECK_DIALOG'
export const CHANGE_OPEN_BRAND_DIALOG = 'CHANGE_OPEN_BRAND_DIALOG'
export const CHANGE_OPEN_KBCORP_DIALOG = 'CHANGE_OPEN_KBCORP_DIALOG'
export const CHANGE_OPEN_SHARE_DIALOG = 'CHANGE_OPEN_SHARE_DIALOG'
export const CHANGE_OPEN_SHARE2_DIALOG = 'CHANGE_OPEN_SHARE2_DIALOG'
export const CHANGE_OPEN_FAQ_DIALOG = 'CHANGE_OPEN_FAQ_DIALOG'
export const CHANGE_OPEN_FOOTER_DIALOG = 'CHANGE_OPEN_FOOTER_DIALOG'
export const CHANGE_OPEN_SHORTS1_DIALOG = 'CHANGE_OPEN_SHORTS1_DIALOG'
export const CHANGE_OPEN_SHORTS2_DIALOG = 'CHANGE_OPEN_SHORTS2_DIALOG'
export const CHANGE_OPEN_SHORTS3_DIALOG = 'CHANGE_OPEN_SHORTS3_DIALOG'
export const CHANGE_OPEN_SHORTS4_DIALOG = 'CHANGE_OPEN_SHORTS4_DIALOG'
export const CHANGE_OPEN_SHORTS5_DIALOG = 'CHANGE_OPEN_SHORTS5_DIALOG'
export const UPDATE_CURRENT_CALENDAR_LABEL = 'UPDATE_CURRENT_CALENDAR_LABEL'
export const CHANGE_OPEN_CALENDAR_DIALOG = 'CHANGE_OPEN_CALENDAR_DIALOG'
export const UPDATE_CURRENT_TEAM = 'UPDATE_CURRENT_TEAM'
export const UPDATE_CURRENT_TEAM_CHART_DATA = 'UPDATE_CURRENT_TEAM_CHART_DATA'
export const UPDATE_CURRENT_TEAM_CARD_DATA = 'UPDATE_CURRENT_TEAM_CARD_DATA'
export const UPDATE_CURRENT_TEAM_EVENT_DATA = 'UPDATE_CURRENT_TEAM_EVENT_DATA'
export const UPDATE_CURRENT_EVENT_DATA = 'UPDATE_CURRENT_EVENT_DATA'
export const UPDATE_OPEN_DROPDOWN = 'UPDATE_OPEN_DROPDOWN'
export const UPDATE_CURRENT_CONTENTS_DATA = 'UPDATE_CURRENT_CONTENTS_DATA'
export const UPDATE_CURRENT_CARD = 'UPDATE_CURRENT_CARD'
export const CHANGE_SLOT_INDEX = 'CHANGE_SLOT_INDEX'
